// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"7275e33a","525":"7275e33a"}[chunkId] + ".chunk.css";
};